import { useEffect, useLayoutEffect, useState } from "react";
import {
  GAActions,
  GACategoryName,
  GAEventNames,
  GAUniqueEventIds,
  HomeCarpetFilterCategory,
} from "../../../helpers/Enums";
import { HomeCarpetCategorySelectionType } from "../../../typings/carpet";
import { TagProps } from "../../../typings/tag";
import {
  getMemberPremiumStatus,
  getTagsForFilter,
} from "./../../../services/memberService";
import { setHomeCarpetFilterCategory } from "./../../../redux/carpet";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { NavLink, useHistory } from "react-router-dom";
import { HOME_SEARCH_USER, SELECT_MOOD } from "../../../navigation/Constants";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

declare global {
  interface Window {
    Webflow: any;
  }
}

export interface HomeFilterProps {
  memberCode: number;
}

const HomeFilter = ({ memberCode }: HomeFilterProps) => {
  const [tags, setTags] = useState<TagProps[]>([]);
  const [options, setOptions] = useState<HomeCarpetCategorySelectionType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { homeFilterCategory: selected } = useSelector(
    (state: RootState) => state.carpet
  );
  const member = useSelector((state: RootState) => state.member);

  const history = useHistory();

  const dispatch = useDispatch();

  const premiumMessagelink = usePrepareLink({
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.premiumMessage,
    },
    keepOldQuery: true,
  });

  useEffect(() => {
    setIsLoading(true);
    setFilterOptions();
    fetchData();
    // fixed in app.tsx line 34 useEffect
    // onOptionSelect({
    //    value: HomeCarpetFilterCategory.AVAILABLE_NOW,
    //    text: "פעילים לאחרונה"
    // });
  }, []);

  const setFilterOptions = () => {
    const filterOptions = [
      {
        value: HomeCarpetFilterCategory.AVAILABLE_NOW,
        text: "כל החברים",
      },
      {
        value: HomeCarpetFilterCategory.IN_MY_MOOD,
        text:
          member.moodText !== null
            ? `פרטנרים ל${member.moodText}`
            : "בחירת פעילות משותפת",
      },
      {
        value: HomeCarpetFilterCategory.LAST_SEEN_ONLINE,
        text: "נראו לאחרונה",
      },
      {
        value: HomeCarpetFilterCategory.ORDER_BY_SIMILAR_TAGS,
        text: "מתאימים לך",
      },
      // {
      //    value: HomeCarpetFilterCategory.PREMIUM,
      //    text: "פרימיום"
      // },
      {
        value: HomeCarpetFilterCategory.ORDER_BY_NEW,
        text: "חדשים בשושק'ה",
      },
      {
        value: HomeCarpetFilterCategory.VERIFIED_MEMBERS,
        text: "חברים מאומתים",
      },

      // {
      //    value: HomeCarpetFilterCategory.CLOSE_TO_ME,
      //    text: "קרובים אליי"
      // }
    ];
    setOptions(filterOptions);
  };

  const fetchData = async () => {
    const { data } = await getTagsForFilter(memberCode);
    setTags(data);
    setIsLoading(false);
    window.Webflow.destroy();
    window.Webflow.ready();
  };

  const onOptionSelect = async (option: HomeCarpetCategorySelectionType) => {
    recordGaEvent(
      GAEventNames.APP_ENGAGMENT,
      GACategoryName.FILTER_USAGE,
      GAActions.CLICK,
      option.text,
      GAUniqueEventIds.APP_ENGAGMENT
    );

    if (!(await canMemberUsePremiumOptions(option))) {
      history.push(premiumMessagelink);
      return;
    }

    if (
      option.value === HomeCarpetFilterCategory.IN_MY_MOOD &&
      !member.moodImage
    ) {
      history.push(SELECT_MOOD);
    }
    dispatch(setHomeCarpetFilterCategory(option));
    changeFilter();
  };

  const canMemberUsePremiumOptions = async (
    option: HomeCarpetCategorySelectionType
  ) => {
    //todo add try catch
    try {
      if (
        option.value === HomeCarpetFilterCategory.ORDER_BY_NEW ||
        option.value === HomeCarpetFilterCategory.VERIFIED_MEMBERS
      ) {
        const { data: isPremium } = await getMemberPremiumStatus();
        return isPremium;
      } else {
        return true;
      }
    } catch (ex) {
      return false;
    }
  };

  const onTagSelect = (tag: TagProps) => {
    const tagFilter: HomeCarpetCategorySelectionType = {
      value: HomeCarpetFilterCategory.TAG,
      text: tag.text,
      tagValue: tag.value,
    };
    dispatch(setHomeCarpetFilterCategory(tagFilter));
    changeFilter();
  };

  const changeFilter = () => {
    let element = document.getElementById("w-dropdown-toggle-0");
    element?.dispatchEvent(new Event("w-close", { bubbles: true }));
  };

  return (
    <>
      <div
        data-hover="false"
        data-delay={0}
        className="top_menu w-clearfix w-dropdown"
      >
        <div
          className="top_menu_button w-dropdown-toggle"
          id="w-dropdown-toggle-0"
          aria-controls="w-dropdown-list-0"
          aria-haspopup="menu"
          aria-expanded="false"
          role="button"
          tabIndex={0}
        >
          <div className="menu_button_txt">סינון</div>
        </div>

        <nav className="top_menu_list w-dropdown-list">
          {options.map((option, key) => {
            return (
              <a
                key={key}
                onClick={() => onOptionSelect(option)}
                href="#"
                className={
                  "top_menu_link w-dropdown-link" +
                  (option.value === HomeCarpetFilterCategory.ORDER_BY_NEW ||
                  option.value === HomeCarpetFilterCategory.VERIFIED_MEMBERS
                    ? " premium"
                    : "")
                }
              >
                {option.text}
              </a>
            );
          })}
          <ul className="tag_list menu w-list-unstyled">
            {tags.map((tag, key) => {
              if (tag.text !== "לא רלוונטי") {
                return (
                  <li key={key} className="tag_item">
                    <a
                      href="#"
                      onClick={() => onTagSelect(tag)}
                      className="tag_link"
                    >
                      {tag.text}
                    </a>
                  </li>
                );
              }
            })}
          </ul>
        </nav>

        <NavLink
          className={"top_search_link w-inline-block"}
          to={HOME_SEARCH_USER}
        >
          <img src="/assets/images/ic_search_1.svg" loading="lazy" alt="" />
        </NavLink>

        {/* <a href="#" className="top_search_link w-inline-block">
          <img src="/assets/images/ic_search_1.svg" loading="lazy" alt="" />
        </a> */}
      </div>

      <h1 className="top_title">{selected.text}</h1>
    </>
  );
};

export default HomeFilter;
